import { SeeqNames } from '@seeqdev/constants';
import { fcCapsuleSet, fcScalar, fcSeries } from '@seeqdev/icons/seeq';
import type { IconDefinition } from '@seeqdev/icons';

export const defaultContamination = 0.1;
export const minNumEstimators = 1;
export const maxNumEstimators = 200;
export const minContamination = 0;
export const maxContamination = 0.5;

const packageName = SeeqNames.MlService.IsolationForest.Connection.UdfPackage;
const udfName = SeeqNames.MlService.IsolationForest.Connection.UdfName;
export const UDF_NAME = `${packageName}_${udfName}`;

export const DEFAULT_NUM_ESTIMATORS = 10;
export const DEFAULT_CONTAMINATION = 0.1;
export const DEFAULT_BOOTSTRAP = false;
export const MAX_INPUT_SIGNALS = 50;

export const INPUT_NAMES = {
  numEstimatorsInput: 'numEstimatorsInput',
  contaminationInput: 'contaminationInput',
  randomStateInput: 'randomStateInput',
  bootstrapInput: 'bootstrapInput',
  startTimeInput: 'startTimeInput',
  endTimeInput: 'endTimeInput',
  signalInput: 'signalInput',
  restrictOutputToConditionInput: 'restrictOutputToConditionInput',
  trainWithinConditionInput: 'trainWithinConditionInput',
  mergeCapsuleDurationInput: 'mergeCapsuleDurationInput',
  minCapsuleDurationInput: 'minCapsuleDurationInput',
};

export const OUTPUT_TRANSLATION_KEYS: Record<string, { label: string; icon: IconDefinition }> = {
  anomalyOutput: {
    label: 'INVESTIGATE_TOOLS.ISOLATION_FOREST_V2.OUTPUTS.ANOMALY_CONDITION',
    icon: fcCapsuleSet,
  },
  scoresSignalOutput: {
    label: 'INVESTIGATE_TOOLS.ISOLATION_FOREST_V2.OUTPUTS.ANOMALY_SCORE_SIGNAL',
    icon: fcSeries,
  },
  modelInputPropertiesOutput: {
    label: 'INVESTIGATE_TOOLS.ISOLATION_FOREST_V2.OUTPUTS.MODEL_INPUT_PROPERTIES',
    icon: fcScalar,
  },
  trainingWindowConditionOutput: {
    label: 'INVESTIGATE_TOOLS.ISOLATION_FOREST_V2.OUTPUTS.TRAINING_WINDOW_CONDITION',
    icon: fcCapsuleSet,
  },
};

export const DEFAULT_OUTPUTS: string[] = ['anomalyOutput', 'scoresSignalOutput'];

export const MODEL_NAME = SeeqNames.ModelNames.IsolationForest;
